<template>
    <div class="lc_tooltip">
        <div class="TQ_grid_col_1frAuto TQ_width_100p">
            <input class="TQ_borderBox TQ_grid_verticalCenter"
                   :placeholder="p_placeholder_s"
                   :class="[p_inputClass_s, {'TQ_textColor_red': co_showError_b} ]"
                   @input="m_input_f"
                   @change="m_change_f"
                   autocomplete="false"
                   :disabled="p_disable_b"
                   v-model="val_o" :type="p_inputType_s" :min="p_min_n"  :max="p_max_n">

            <tq-image v-if="co_showError_b" :pb_src_r="ass_img_closeRed" class="TQ_width_16px TQ_inline lc_redButton TQ_grid_verticalCenter"/>

        </div>

        <div class="TQ_textColor_red TQ_text_14px lc_tooltiptext TQ_box_shadow2 TQ_width_maxContent TQ_padding_8px TQ_borderBox TQ_text_capitalize_first_letter"
             v-if="co_showError_b">
            {{p_error_s}}
        </div>

    </div>
</template>

<script>
import {enum_inputType} from "../../../functions/src/shareCode/Share_S_Enum";
import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import TqMoreInfo from "@/components/basic2/TqMoreInfo";
import TqImage from "@/components/basic/TqImage";
import {ass_img_closeRed, ass_img_lockImage_b} from "@/assets/scripts/Ass_Files";

export default {
    name: "TqErrorInput",
    components: {TqImage, TqMoreInfo},
    props:{
        p_inputClass_s:{
            type: String
        },
        p_max_n:{
            type: Number
        },
        p_min_n:{
            type: Number
        },
        p_val_o:{
            require: true,
        },
        p_inputType_s:{
            type: String,
            validator(val_s){
                return validator_enum_fb(enum_inputType, val_s)
            }
        },
        p_placeholder_s: {
            type: String
        },
        p_error_s: {
            require: true,
            type: String
        },
        p_disable_b:{
            type: Boolean,
            default: false
        },

        // functions
        pe_input_f: {
            type: Function,
            default: () => {
                return () => {}
            }
        },
        pe_change_f: {
            type: Function,
            default: () => {
                return () => {}
            }
        },

    },
    data(){
        return {
            val_o : this.p_val_o,

            foundFirstError_b : false,
            firstInputChanged_b : false,

            // import
            ass_img_closeRed : ass_img_closeRed,

        }
    },
    computed:{
        co_showError_b(){

            return this.foundFirstError_b && this.p_error_s != null
        }
    },
    methods:{
        m_input_f(){
            let ans = this.p_inputType_s === enum_inputType.number_s ? parseInt(this.val_o) : this.val_o
            this.pe_input_f(ans)
        },
        m_change_f(){
            let ans = this.p_inputType_s === enum_inputType.number_s ? parseInt(this.val_o) : this.val_o
            this.pe_change_f(ans)

            this.foundFirstError_b = this.foundFirstError_b || this.p_error_s != null

        }
    },
    created() {
        this.m_input_f()
    }
}
</script>

<style scoped>
.lc_tooltip {
    position: relative;
    display: inline-block;
}

.lc_redButton{
    margin: -24px;
}

.lc_tooltip .lc_tooltiptext {
    background: white;
    text-align: center;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 0;
    transition: opacity 0.3s;
    max-width: 100%;
    /*margin-left: 16px;*/

}

.lc_tooltip .lc_tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    /*margin-left: -5px;*/
    border-width: 5px;
    border-style: solid;
    border-color: white transparent transparent transparent;
}


</style>